module.exports = __webpack_public_path__ + "static/media/town_scene.6aa28734.svg";